export const moduleSlug = 'cms'
export const moduleAuth = 'Cms';
const StudioCmsUrl = import.meta.env.VUE_APP_STUDIO_CMS_URL


export const children = [
  {
    path: "",
    component: () => import("./pages/Apps.vue"),
    props: { selectedModule: moduleSlug },
    meta: {
      title: "Apps",
      linkTitle: "Apps",
      linkIcon: "users",
      showInNav: true,
      permission: "Cms.Headless",
    },
  },
  {
      path: "apps/create",
      component: () => import("./pages/AddOrUpdateApp.vue"),
      props: { selectedModule: moduleSlug },
      meta: {
          title: "Create - App",
          showInNav: false,
          permission: "Cms.Headless",
      },
  },
  {
      path: "apps/:appId/update",
      component: () => import("./pages/AddOrUpdateApp.vue"),
      props: { selectedModule: moduleSlug },
      meta: {
        title: "Update - App",
        showInNav: false,
        permission: "Cms.Headless",
      },
  },
  {
    path: 'apps/:appId/content',
    component: () => import("./pages/contentSection/Layout.vue"),
    props: { selectedModule: moduleSlug },
    meta: {
      title: 'Content - App',
      showInNav: false,
      permission: "Cms.Headless",
    },
    children: [
      {
        path: '',
        component: () => import("./pages/contentSection/DummyPage.vue")
      },
      {
        path: ':modelId',
        component: () => import("./pages/contentSection/ContentView.vue")
      },
      {
        path: ':modelId/:index',
        component: () => import("./pages/contentSection/AddOrUpdateContent.vue"),
        props: { isObjectShow: true }
      },
      {
        path: ':modelId/create',
        component: () => import("./pages/contentSection/AddOrUpdateContent.vue")
      },
      {
        path: ':modelId/update',
        component: () => import("./pages/contentSection/AddOrUpdateContent.vue")
      },
      {
        path: ':modelId/update/:index',
        component: () => import("./pages/contentSection/AddOrUpdateContent.vue")
      },
    ]
  },
  {
    path: 'media-library',
    component: () => import('./pages/MediaLibrary.vue'),
    props: { selectedModule: moduleSlug },
    meta: {
      title: 'Media library',
      linkTitle: 'Media library',
      linkIcon: 'picture-o',
      showInNav: true,
      permission: "Cms.Headless",
    }
  },
  {
    path: StudioCmsUrl,
    component: () => import('./pages/MediaLibrary.vue'),
    props: { selectedModule: moduleSlug },
    meta: {
      title: 'Studio CMS',
      linkTitle: 'Studio CMS',
      linkIcon: 'wikipedia-w',
      showInNav: true,
      permission: "Cms.Studio",
      isUrl: true,
      query: ['brandUri:brand']
    }
  },
  {
    path: 'forms',
    component: () => import('./pages/Forms.vue'),
    props: { selectedModule: moduleSlug },
    meta: {
      title: 'Forms',
      linkTitle: 'Forms',
      linkIcon: 'file-text-o',
      showInNav: true,
      permission: "Cms.Forms",
    }
  },
  {
    path: 'forms/create',
    component: () => import('./pages/AddOrUpdateForm.vue'),
    props: { selectedModule: moduleSlug },
    meta: {
      title: 'Forms | Create',
      linkTitle: 'Forms',
      linkIcon: 'file-text-o',
      showInNav: false,
      permission: "Cms.Forms",
    }
  },
  {
    path: 'forms/:formId/update',
    component: () => import('./pages/AddOrUpdateForm.vue'),
    props: { selectedModule: moduleSlug },
    meta: {
      title: 'Forms | Update',
      linkTitle: 'Forms',
      linkIcon: 'file-text-o',
      showInNav: false,
      permission: "Cms.Forms",
    }
  },
  {
    path: 'forms/:formId/responses',
    component: () => import('./pages/FormResponses.vue'),
    props: { selectedModule: moduleSlug },
    meta: {
      title: 'Forms | Responses',
      linkTitle: 'Forms | Responses',
      linkIcon: 'file-text-o',
      showInNav: false,
      permission: "Cms.Forms",
    }
  },
];